import { apiClient } from './client'

export interface Vehiculo {
  id: string
  tenantId: string
  codigo: string
  tipoMaquinaId: string
  marca: string | null
  modelo: string | null
  anio: number | null
  capacidadTanque: number | null
  horometroInicial: number
  gpsImei: string | null
  activo: boolean
  creadoAt: string
  tipoMaquina?: { nombre: string; consumoLitrosHoraEsperado: number }
}

export interface VehiculoInput {
  codigo: string
  tipoMaquinaId: string
  marca?: string
  modelo?: string
  anio?: number
  capacidadTanque?: number
  horometroInicial?: number
  gpsImei?: string
}

export const vehiculosApi = {
  list: () =>
    apiClient.get<{ items: Vehiculo[] }>('/vehiculos').then((r) => r.data),

  getById: (id: string) =>
    apiClient.get<Vehiculo>(`/vehiculos/${id}`).then((r) => r.data),

  create: (data: VehiculoInput) =>
    apiClient.post<Vehiculo>('/vehiculos', data).then((r) => r.data),

  update: (id: string, data: Partial<VehiculoInput>) =>
    apiClient.patch<Vehiculo>(`/vehiculos/${id}`, data).then((r) => r.data),

  toggleActivo: (id: string, activo: boolean) =>
    apiClient.patch<Vehiculo>(`/vehiculos/${id}`, { activo }).then((r) => r.data),
}
